import type { BreadcrumbItem } from '@acme/foundation';
import type { NavigateFunction } from 'react-router-dom';

export const getApplicationBreadcrumbs = (
  navigate: NavigateFunction,
  code?: string | null
): BreadcrumbItem[] => [
  { label: 'Главная', onClick: () => navigate('/dashboard') },
  { label: code ? `Заявка ${code}` : 'Заявка' },
];

export const getApplicationsListBreadcrumbs = (
  navigate: NavigateFunction
): BreadcrumbItem[] => [
  { label: 'Главная', onClick: () => navigate('/dashboard') },
  { label: 'Заявки' },
];
